import { IconButton, Tooltip } from '@mui/material';
import { useState } from 'react';
import { useTheme } from 'styled-components';
import { IoIosAddCircleOutline, IoMdAdd, IoMdClose } from 'react-icons/io';
import ErrorIcon from '@mui/icons-material/Error';
import { Content, Container } from './styles';

type Props = {
  onAdd: (text: string) => boolean;
  placeholder?: string;
  defaultShowInput?: boolean;
  messageError?: string;
  onChangeIfShowInput: (showInput: boolean) => void;
};

export function InputAdd({
  onAdd,
  placeholder,
  defaultShowInput,
  messageError,
  onChangeIfShowInput,
}: Props) {
  const theme = useTheme();
  const [value, setValue] = useState('');
  const [displayInput, setDisplayInput] = useState(!!defaultShowInput);

  const handleAdd = () => {
    if (value) {
      const hasError = onAdd(value);
      if (!hasError) {
        setValue('');
        handleChangeIfShowInput(false);
      }
    }
  };
  const handleChangeIfShowInput = (show: boolean) => {
    onChangeIfShowInput(show);
    setDisplayInput(show);
    setValue('');
  };
  return (
    <Container>
      <Content hasBorder={displayInput}>
        {displayInput && (
          <input
            type="text"
            placeholder={placeholder || 'O que você quer adicionar?'}
            onChange={(e) => setValue(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && value && handleAdd()}
          />
        )}
        {displayInput ? (
          value ? (
            <Tooltip disableInteractive title="Adicionar">
              <IconButton onClick={() => handleAdd()}>
                <IoMdAdd size={30} color={theme.colors.primary} />
              </IconButton>
            </Tooltip>
          ) : (
            <IconButton onClick={() => handleChangeIfShowInput(false)}>
              <IoMdClose size={30} color={theme.colors.primary} />
            </IconButton>
          )
        ) : (
          <IconButton onClick={() => handleChangeIfShowInput(!displayInput)}>
            <IoIosAddCircleOutline size={30} color={theme.colors.primary} />
          </IconButton>
        )}
      </Content>
      {messageError && displayInput && (
        <span className="fieldError">
          <ErrorIcon fontSize="inherit" /> {messageError}
        </span>
      )}
    </Container>
  );
}
